import { isEmpty } from 'lodash';

/**
 * SnailBlast reference data, as the dashboard still needs it: the campaign types a campaign idea
 * can be built for.
 *
 * `snailblast/getLookups` also returns the list-purchase databases and filter fields, and this
 * module used to expose getters over them for the audience filter editor. That editor moved to the
 * CheckoutApp, which fetches the same payload through its own store — so those getters went with it
 * and the extra keys in the response are simply ignored here.
 */

const state = {
  all: {}
};

const getters = {
  all: (state) => {
    return state.all || {};
  },
  campaign_types: (state, getters) => {
    return getters.all.campaign_types || [];
  },
  campaign_type: (state) => (id) => {
    return (state.all.campaign_types || []).find((x) => x.id === id) || {};
  }
};

const mutations = {
  SET_LOOKUPS(state, lookups) {
    state.all = lookups;
  }
};

const actions = {
  async get({ commit, state }) {
    if (!isEmpty(state.all)) {
      return;
    }
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get('snailblast/getLookups')
        .then((response) => {
          commit('SET_LOOKUPS', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
